import {REST_METHODS} from '@/src/app/constants/api';
import {getAuthorizationToken} from '@/src/app/utils/authorizationToken';
import authorizedFetch from '@/src/app/utils/authorizedFetch';
import unauthorizedFetch from '@/src/app/utils/unauthorizedFetch';

/**
 * @param {number} translationId
 */
const getCourseReviews = (translationId) => {
  const param = [
    {
      name: 'course_translation_id',
      value: translationId,
    },
  ];

  const requestMethod = getAuthorizationToken()
    ? authorizedFetch
    : unauthorizedFetch;

  // @ts-ignore
  return requestMethod({
    method: REST_METHODS.GET,
    path: `/api/v1/courses/ratings`,
    queryParams: param,
  });
};

export default getCourseReviews;
